module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-tree",
    class: {
      'el-tree-highlight-current': _vm.highlightCurrent
    }
  }, [_vm._l((_vm.root.childNodes), function(child) {
    return _c('i-tree-node', {
      key: _vm.getNodeKey(child),
      attrs: {
        "node": child,
        "props": _vm.props,
        "render-content": _vm.renderContent
      }
    })
  }), _vm._v(" "), (!_vm.root.childNodes || _vm.root.childNodes.length === 0) ? _c('div', {
    staticClass: "el-tree-empty-block"
  }, [_c('span', {
    staticClass: "el-tree-empty-text"
  }, [_vm._v(_vm._s(_vm.emptyText))])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-b9f1abe6!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/tree/src/tree.vue
// module id = 678
// module chunks = 0